import { action, computed, observable } from "mobx";
import NestStore from "../NestStore";
import MlsServiceRepository from "~/repository/MlsService/MlsServiceRepository";
import MlsService from "~/models/MlsService/MlsService";
import i18n from "~/components/i18n";

class MlsServiceStore extends NestStore {
  /**
   * @property {MlsService[]}
   */
  @observable mlsServices = [];

  /**
   * @property
   * @returns {MlsService[]}
   */
  @computed
  get sortByDisplayName() {
    return this.mlsServices.slice().sort(
      /**
       * @param a {MlsService}
       * @param b {MlsService}
       * @returns {number}
       */
      (a, b) => a.displayName.localeCompare(b.displayName),
    );
  }

  @computed
  get displayNameFormOptions() {
    const mlsServices = this.sortByDisplayName.map(
      /**
       * @param mlsService {MlsService}
       */
      mlsService => {
        return {
          key: mlsService.mlsServiceId,
          value: mlsService.mlsServiceId,
          text: mlsService.displayName,
        };
      },
    );

    mlsServices.unshift({
      key: null,
      value: null,
      text: i18n.t("clientPanelConstants:selectMLSService"),
    });

    return mlsServices;
  }

  constructor() {
    super();
    this.order = "asc";
    this.mlsServiceRepository = new MlsServiceRepository();
  }

  @action
  getAll(params = {}) {
    this.isLoading = true;

    const paramsRequest = {
      offset: this.offset,
      limit: this.pagination.itemsPerPage,
      ...params,
    };

    return this.mlsServiceRepository
      .fetch(paramsRequest)
      .then(response => {
        if (response.status === "success") {
          response.data.mlsServices.forEach(entry => {
            this.mlsServices.push(new MlsService(entry));
          });
        }
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
}

export default MlsServiceStore;
